import { PageContainer, Spinner } from "@shapr3d/frontend-lib";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { OverlayProvider } from "../../components/Headers/components/ShareModal/components/MenuPortal";
import { ViewLinkList } from "../../components/ViewLinkList/ViewLinkList";
import type { User } from "../../hooks/useComments";
import { SyncRequestClient } from "../../stores/requestClient";

import style from "./ViewLinkListPage.module.css";

export type Space = {
  id: string;
  spaceName?: string;
  spaceType: "private" | "team";
};

export type ProjectViewLink = {
  title: string;
  projectViewLinkId: string;
  space?: Space;
  uploadedAt: Date;
  uploadedByUserId: string;
};

export type ProjectViewLinksResponseData = { projectViewLinks: ProjectViewLink[]; users: User[] };

export const projectViewLinksQueryKey = ["projectViewLinks"];

const useProjectViewLinks = (teamId: string | undefined) => {
  return useQuery<ProjectViewLinksResponseData>({
    queryKey: [...projectViewLinksQueryKey, teamId],
    queryFn: async () => {
      const response = await SyncRequestClient.authenticatedRequest({
        method: "GET",
        url: `/web/project-view-links?teamId=${teamId}`,
      });

      return response.json<ProjectViewLinksResponseData>();
    },
    enabled: Boolean(teamId),
  });
};

export default function ViewLinkListPage() {
  const { teamID } = useParams();
  const { data, isLoading } = useProjectViewLinks(teamID);

  if (isLoading) {
    return (
      <div className={style.pageContainer}>
        <Spinner />
      </div>
    );
  }

  return (
    <OverlayProvider>
      <PageContainer title="Review links">
        <ViewLinkList viewLinks={data?.projectViewLinks ?? []} users={data?.users ?? []} />
      </PageContainer>
    </OverlayProvider>
  );
}
